module.exports = " <div style=\"overflow: hidden\"> <div class=swiper> <slot></slot> </div> <pagination v-if=\"direction == 'horizontal'\" :size=itemCount :pager-color=pagerColor :pager-bg-color=pagerBgColor v-ref:pagination></pagination> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/Swiper.vue
// module id = 243
// module chunks = 0